/* eslint-disable quotes */
/* eslint-disable max-len */
export const langFile = {
  common: {
    close: 'Close',
    day: 'day',
    euro: '€',
    included: 'Included',
    noResults: 'No results',
    standardError:
      'Sorry, an unexpected error has occurred, try again later or contact customer services.',
    vatIncluded: 'VAT INCLUDED',
    terminalIn: 'Entry Terminal:',
    terminalOut: 'Exit Terminal:',
    new: 'New',
  },
  confirmationStep: {
    return: 'Back',
    psd2Title: 'Activate your card to be able to use it',
    psd2Body:
      'Your bank asks to validate the card ****{{cardNumber}} in order to use it when you leave. You only need to do it once and you can use it in all your stays with us.',
    psd2Button: 'Validate card',

    instagramTitle: 'Follow us on Instagram',
    instagramBody:
      'The best contents about aparca&go and everything you need to know about your trip. Also enjoy exclusive offers for followers!',
    instagramButton: 'Follow @aparcandgo_es',
    checkCarsevices: 'View Car Service',
    willSendEmail:
      'You will receive an email with all the arrival and return instructions.',
    isFastlane: 'You have the fast lane activated!',
    addServicesQuestion: 'Do you want to add services to your reservation?',
    addServicesText2: 'You are still on time.',
    addServicesClick: 'Click here!',
    reservationNumber: 'Booking number',
    additionalInfo: 'Additional information',
    addServices: 'Add services',
    addServicesBody:
      'There’s still time to make the most of your trip and get your car serviced.',
    agencyReservation: 'You can check the reservation in your Agency Area.',
    appleWallet: 'Apple Wallet',
    cancelReservation: 'Cancel booking',
    carServiceInstructions: 'Car Service',
    checkReservation: 'View booking',
    validateChallengeText:
      'You can speed up check-out by validating your card.',
    validateChallengeButton: 'Validate now',
    confirmationEmailSended: "We're sending you a confirmation email to",
    fastLaneWashWarning:
      '<b>You have booked a car wash.</b> Enter the parking trough the ticket office so that our staff can tell you the area where you should park and leave the keys of your vehicle.',
    covidTitle: 'COVID-19 measures',
    covidBody:
      'We follow all safety measures to ensure you travel with peace of mind.',
    covidLink: '/en/info-covid-19',
    downloadApp: 'Download our app',
    downloadAppText: 'Mange your booking quickly from the aparca&go app',
    downloadReservation: 'Download booking',
    editReservation: 'Change booking',
    fastLaneBody:
      'Enter and exit our parking using the fast lane with the barcode that you will receive in the confirmation email.',
    fastLaneTitle: 'You can park even faster!',
    fastLaneLink: '/en/services/parking/fast-lane',
    gracePeriodTitle: 'Notice about the price of your reservation',
    gracePeriodBody:
      'Remember that you have until {{hours}}h of {{day}} to pick up your vehicle without changes in the price of your reservation. Good trip! (<a title="+info tarifes" href="https://www.aparcandgo.com/en/aviso-legal">+info tarifes</a>)',
    ifNotRegistered:
      'Booking without being registered? You are missing out on a lot of free parking days. <b (click)="registerInConfirmation()"><u>Register now</u></b> and start collecting points with aparca&go.',
    ifSporadicWithRegisteredEmail:
      'With this booking you can accumulate {{newPoints}} euros. <br> Link your reservation to your user account to continue accumulating euros and taking advantage of your <u (click)="navigateToUserPanel()">user area.</u>',
    linkReservationCTA: 'Link reservation',
    ifRegisteredPoints:
      'With this stay you will accumulate {{newPoints}} euros',
    ifRegisteredPointsUser: ' on your current {{userPoints}} balance.',
    instructions: 'instructions',
    itv: 'ITV',
    maintenance: 'Car Service',
    manageReservation: 'Manage your booking',
    moreInfo: 'More information',
    others: 'Other',
    paymentBody: 'Pay for this booking at the exit.',
    paymentBodyExpress: 'You can pay by cash, card, or using our App.',
    paymentTitleExpress:
      'Pay your stay in our parking at the ticket office before leaving. ',
    paymentBodyPremium: 'You can pay by credit card or using our App.',
    paymentTitlePremium: 'Pay your service when picking up your car. ',
    paymentTitleUrban:
      'Pay your stay at the {{urbanParkingName}} when collecting the keys of your vehicle at the box office before leaving the parking lot.',
    paymentTitle:
      'Payment is to be made at the car park (Express and Stations) or when collecting in Premium service.',
    reviews: 'Car Tune up',
    thanks: 'Thank you for booking!',
    updated: 'Your reservation has been updated!',
    wash: 'Car wash',
    keysNeededReminder:
      'Remember that the reservation requires leaving the key in the box office.',
    CTAForm2Title: 'Save your time and efforts!',
    CTAForm2Body:
      'Add services to your reservation to take the opportunity to get your car ready: car wash, refueling or recharging, tire inflation, change of filters and oils, pass the ITV, etc... or even have your car officially checked.',
    CTAForm2BodyShort:
      'Add services to your reservation to take the opportunity to get your car ready.',
    CTAForm2Click: 'Add services',
  },
  errorTailor: {
    email: 'Invalid email',
    maxLength: 'Must not contain more than {{requiredLength}}',
    minLength: 'Must contain {{requiredLength}} or more characters',
    required: 'This field is required',
    requiredDni:
      'This is not a valid ID document. Make sure you are adding a DNI number without spaces, hyphens or periods in case your business name is a name and surname (Physical Person) Ex: 11222333X. Make sure you are adding a company NIF without spaces, hyphens or points in case your business name is a company (Legal) Ex: B11222333. ',
    vatErrorFormatVies:
      'Make sure that if you are outside of Spain and within the EEC, add the VAT number without spaces, hyphens, or points. Ex: PT111222333',
    requiredEmail: 'We will send your confirmation here',
    requiredPhone: 'We will contact you if necessary',
    requiredSignPlate: 'Which vehicle are you going to park with',
    invalidNameDni:
      'This NIF belongs to a DNI, please insert name and surnames.',
    invalidNameNie:
      'This NIF belongs to a NIE, please insert name and surnames.',
  },
  homeModule: {
    homeForm: {
      email: 'Email',
      name: 'Name',
      needInvoice: 'I need an invoice',
      phone: 'Telephone',
      signPlate: 'Number plate',
      surname: 'Surname',
      title: 'Booking details',
      travelForWork: 'I’m travelling for work',
    },
  },
  notFoundPage: {
    message: 'Not found page',
  },
  navTab: {
    availableServices: 'Available services',
    confirmation: 'Confirmation',
    five: '5',
    four: '4',
    howToPark: 'How do you want to park',
    one: '1',
    summary: 'Summary',
    three: '3',
    travelerData: "Traveller's information",
    two: '2',
    whereAndWhen: 'Where and when',
  },
  productsStep: {
    bkgAenaDialog: {
      text1:
        'The savings discount compared to the official parking is calculated using the standard rate without reservation.',
      text2:
        'Although we monitor these prices on an ongoing basis, these rates are subject to change without notice. If you are unsure about the price or discount you are looking at, don’t hesitate to <a href="/en/contact-phone-email">contact us</a>, and we will be happy to answer any questions you have.',
      title: 'Price comparison',
    },
    bkgProductCard: {
      aena: 'AENA',
      badDatesBody: 'To enjoy this service choose other dates.',
      badDatesTitle: 'Not available for these dates!',
      freeCancellation: 'Free cancellation',
      minutes: 'min.',
      moreInfo: 'More info +',
      payTheParking: 'You pay at the parking',
      saving: 'saving',
      select: 'Choose',
      highDemandMessage: 'There is high demand for the dates you want!',
      almostOutMessage: 'They are very few places for the dates you want!',
      outOfStockMessage: 'Last places available!',
      allTypePlacesOutMessage:
        'Not available for these dates! <br> <div>To enjoy this service choose other dates.<div>',
    },
    bkgTripInfoCruiserName: {
      cruiserName: 'Cruise ship name',
      info:
        'In order for us to pick you up, please provide us with the name of the cruise ship',
      others: 'Others',
    },
    bkgTripInfoDialog: {
      aboutYourTravel: 'Details of your trip',
      continue: 'Continue',
      alert:
        'From July {{startDay}} to September {{endDay}} vehicles over 5,5 meters cannot access the car park',
    },
    bkgTripInfoExtras: {
      add: 'Add +',
      added: 'Included!',
      externalPlace: 'Outside',
      improvePlace: 'Choose your type of parking slot',
      highDemandMessage: 'There is high demand for the dates you want!',
      almostOutMessage: 'They are very few places for the dates you want!',
      outOfStockMessage: 'Sold out',
      busClaim: 'You will park right next to the bus stop!',
    },
    bkgTripInfoPassengers: {
      passengersIn: 'Outbound passengers',
      passengersOut: 'Return passengers',
      passengersTooltip:
        'We need to know the number of passengers to be able to plan passenger traffic and give you the best service. There is no extra cost per extra passenger.',
      passengersTransfer: 'How many passengers need to be transferred?',
    },
    bkgTripInfoReturnFlight: {
      addReturnFlight:
        'Please provide us with your return flight number for us to pick you up at time',
      returnFlight: 'IB1234',
    },
    bkgProductsPage: {
      selectDeliverCar: 'Choose how to park',
      highDemandMessage: 'There is high demand for the dates you want!',
      almostOutMessage: 'They are very few places for the dates you want!',
      outOfStockMessage:
        'There is no availability in the parking for the selected dates. Try to book for another date.',
    },
  },
  sharedModule: {
    bkgSummaryVouchers: {
      title: "Redeem your coupons!",
      discount_percent: "{{value}}% off",
      discount_euro: "{{value}}€ off",
      expires_on: "Expires on   <br> {{date}}",
    },
    bkgVoucherBanner: {
      title_singular: "You have 1 coupon available!",
      title_plural: "You have {{count}} coupons available!",
      body: "Redeem your coupons!"
    },
    bkgCookiesAdvice: {
      accept: 'Understood',
      reject: 'Reject',
      textHtml:
        'This website uses first party and third-party cookies to perform analytical work and obtain statistics on the use of the website by users. You can configure the cookies established at any time and obtain more information about it in the <a href="/en/cookies-policy" title="">Cookies Policy</a>.',
    },
    bkgCustomTiresService: {
      added: 'Service successfully added.',
      title: 'Tire change',
      body:
        'Take advantage of the fact that your car is parked to change the tires. We will send you a budget so that you accept it before arriving at the car park.',
    },
    bkgCustomServices: {
      added: 'Service successfully added.',
      title: "Can't you find the service you need?",
      body1: "That's OK! We can help you anyway.",
      body2:
        'Ask us what you need and we will try our best to provide you a tailored solution.',
      notes: 'Requests the services you need',
      terms:
        'By sending this request you are accepting the terms of service of aparca&go. We inform you that, aparca&go S.L. as responsible for the file, you process the data with the sole purpose of managing the query.',
    },
    bkgHeader: {
      account: 'Your account',
      greeting: 'Hi',
      login: 'Log in',
      logout: 'Log out',
      reservation: 'Your bookings',
      businessMode: 'Switch to Company profile',
      individualMode: 'Switch to Individual profile',
      signUp: 'Register',
    },
    bkgFeedbackDialog: {
      profileTitle: 'Profile successfully added',
      profileBody: 'You can now use the billing profile {{profile}}',
      registerTitle: 'Registration successful',
      registerBody:
        'TWe have sent an email to {{email}} so you can confirm your email address',
      servicesTitle: 'Service successfully added',
      servicesBody:
        'You can continue adding services to your booking, or click on Continue to complete your booking',
      customServicesTitle: 'Custom Service added!',
      customTiresServiceTitle: 'Tire change Service added!',
      customServicesBody:
        'Finish your reservation and we will contact you to inform you of the availability and cost of the service you have requested.',
      vehicleTitle: 'Vehicle added',
      vehicleTitleEdit: 'Edited vehicle',
      vehicleBody:
        'We have successfully added the vehicle {{plate}} - {{model}}  to your profile',
      vehicleDangerTitle: 'Vehicle not found',
      vehicleDangerBody: 'Please select the make and model manually',
    },
    bkgFooter: {
      privacyLink: '/en/privacy-policy',
      legalLink: '/en/legal-notice',
      siteMapLink: '/en/sitemap',
      privacy: 'Privacy',
      legal: 'Legal Notice',
      siteMap: 'Sitemap',
      copyright: '© 2024 aparca&go S.L. All rights reserved.',
    },
    bkgHourPicker: {
      titleStart: 'What time would you like to drop-off the car?',
      titleEnd: 'What time would you like to pìck-up the car?',
      info:
        '<p>Our shuttle bus (Express booking) will drop you off at the terminal door in 5 minutes, however we still recommend you arrive at the car park in plenty of time to park calmly.</p> <p>If you prefer to drop your car off directly at the terminal (Premium booking), please select the exact time you are planning on arriving at the airport. We’ll be waiting!</p>',
      infoShip:
        '<p>Choose your check-in time: 8:00 am, 9:15 am, 10:30 am, 12:30 am or 12:30 pm . Once parked you will have 30 minutes to catch our free minibus that will take you directly to the parking lot of the Port Cruise Terminal.</p>',
    },
    bkgInfoSectionDialog: {
      addToMyBooking: 'Add service',
      checkControls: "We'll check {{ controlsLength }} control points",
      removeFromMyBooking: 'Remove from my booking',
      select: 'Select',
      calculatePrice: 'Calculate price',
      price: 'Price',
      vat: 'VAT (21%)',
      totalPrice: 'TOTAL CAR SERVICE',
    },
    bkgAlternativeOfferDialog: {
      title: 'This product is not available',
      booking: 'Confirm change',
      changesDatesOrProduct: 'I want to change dates',
      infoTooltip: '{{description}}',
      newPrice: 'New price: ',
    },
    bkgInitialBookingDataDialog: {
      anotherTerminal: "I'm returning to another terminal",
      bookingBtn: 'Book',
      dateAndTime: 'Date and time',
      entrance: 'Drop-off',
      exit: 'Pick-up',
      where: 'Where?',
      parking: 'Parking',
      selectParking: 'Select parking',
      title: 'Select parking',
      dates: 'Update reservation',
      datesBtn: 'Continue',
      deliverCar: 'How do you want to drop-off your car?',
      pickup: 'Where do you need us to transfer you to?',
      welcomeTitle: 'Everything your car needs while you\'re traveling',
      welcomeBody:
        'Reserve your parking space, add the workshop services you need, and park quickly, comfortably and safely.',
    },
    bkgLoginDialog: {
      accountMessage: 'Do you have an aparca&go account?',
      bodyTitle: 'Log in to your account',
      continueRegistration: 'Continue without registering',
      email: 'Email',
      facebookBtn: 'Facebook',
      forgetPassword: 'Recover password',
      googleBtn: 'Google',
      appleBtn: 'Apple',
      loginBtn: 'Log in',
      password: 'Password',
      signUpFree: 'Register for free',
      title: 'Book even faster',
      individualCustomer: 'Individuals',
      agencies: 'Agencies',
      agencyTitle: 'Log in to your Agency account',
      alias: 'User',
    },
    bkgRecoveryPassDialog: {
      title: 'Recover password',
      body:
        'Enter the email address associated with your account and we will send you the link to reset your password',
      send: 'Send link',
      checkMail: 'Check your email',
      accept: 'understood',
      mailSended:
        'TWe have sent an email to  {{ email }}  so you can reset your passwor',
    },
    bkgSignUpDialog: {
      access: 'Log in',
      bodyTitle:
        'Register to book faster and collect points that can be redeemed for discounts.',
      cancel: 'Cancel',
      promoEmails:
        'I agree to receive communications of news, promotions and discounts from aparca&go',
      newsletterEmails: 'I agree to receive the newsletter',
      continueBtn: 'Continue without registering',
      createError: 'There’s an error! Please check the details and try again',
      email: 'Email',
      haveAccount: 'Do you already have an account?',
      name: 'Name',
      password: 'Password',
      privacyPolicy:
        'I have read and understood the <a href="/en/privacy-policy">Privacy policy</a>',
      signUpFree: 'Register for free',
      signUpWithFb: 'Facebook',
      signUpWithGoogle: 'Google',
      signUpWithApple: 'Apple',
      surname: 'Surname',
      title: 'Register for free',
    },
    bkgSummary: {
      acceptPromos:
        'I agree to receive communications of news, promotions and discounts from aparca&go.',
      acceptNewsletter: 'I agree to receive the newsletter.',
      acceptTerms:
        'I accept the <a href="/en/privacy-policy" target="_blank" title="Política de privacidad"><strong>Privacy policy</strong></a> and the <a href="/en/legal-notice" title="Condiciones de uso aparca&go" target="_blank"><strong>terms of use</strong></a>',
      book: 'Book now',
      carInsuranceTerms:
        'I declare that the vehicle is covered by compulsory motor vehicle insurance and the corresponding administrative authorisation to drive.',
      carServiceTerms:
        'I authorise aparca&go and its associated garages to drive my vehicle for the minimum time necessary to carry out the contracted services.',
      continue: 'Continue',
      needServices: 'You need to select at least one service to continue',
      disabledTerms: 'Accept the contract conditions.',
      disabledBookingForm: 'Check the booking details.',
      disabledBillingForm: 'Check the invoice details.',
      estimateAccept: 'By booking you are accepting the quote',
      reservationNumber: 'Booking number',
      return: 'Return',
      termsAccepted:
        'By booking you are accepting the <a href="/es/politica-privacidad" target="_blank" title="Política de privacidad"><strong>terms</strong></a> and <a href="/es/aviso-legal" title="Condiciones de uso aparca&go" target="_blank"><strong>conditions of use of aparca&go.</strong></a>',
    },
    bkgSummaryDiscounts: {
      availablePoints: 'Your available accumulated euros:',
      discount: 'Discount:',
      havePromoCode: 'Do you have a promotional code?',
      insertCode: 'Enter your code',
      pointsApplied: '¡{{ points }} euros successfully applied!',
      promoFailed: 'Invalid code',
      promoSuccess: 'Your promotional code has been successfully applied!',
      redeem: 'Redeem',
      validate: 'Validate',
      wantUsePoints: 'Do you want to use your euros?',
    },
    bkgSummaryLocation: {
      location: 'Parking location',
      premiumLocation: 'Delivery point',
      locationDescription: "View the parking's location on the map.",
      openMap: 'open map',
      parkingLocation: 'Parking location',
      howToGet: 'Directions',
    },
    bkgSummaryPrice: {
      carServiceDiscount: 'Car Service Discount',
      customService: 'Personalized Service',
      customTiresService: 'Tire change',
      free: 'Free',
      freeCancellation: 'Free cancellation',
      payInParking: 'Pay at the parking',
      place: 'Space',
      doubleSpace: 'Double space',
      points: 'Accumulated euros',
      price: 'Services and price',
      promo: 'Promo',
      total: 'TOTAL',
      wash: 'Car wash',
      totalWithoutPromo: 'TOTAL WITHOUT PROMO',
      removal: 'Removal',
      taxesSentence2:
        '(*) Official rates according to vehicle emission type: €40.60 gasoline, €45.59 diesel, €54.98 industrial diesel van...)',
      taxesSentence3: '(*) Official rates according to vehicle emission type',
      carDiscountTitle: 'Car Service Promo Discounts',
      carDiscountBody:
        'You have selected services worth {{total}}€ so you get a {{discount}}% discount on the cost of your Parking.<br><br>Table of discounts on parking when adding Car Service services:<br><br>25% on Parking from 99€ at Car Service<br>50% on Parking from 199€ at Car Service<br>75% on Parking from 299€ at Car Service<br>Free Parking up to 40€ from 499€ at Car Service!',
      carFerryBody:
        'In bookings with Car Service services of less than 200€ we add the cost of transferring the vehicle to the workshop. Add more services to eliminate the transfer cost.',
    },
    bkgSummaryReservation: {
      checkIn: 'Drop-off:',
      checkOut: 'Pick-up:',
      checkInPremium: 'Drop-off:',
      checkOutPremium: 'Pick-up:',
      diffTimeZone: "Spain's Timezone",
      data: 'Details',
      email: 'Email:',
      flightNumber: 'Return flight:',
      modify: 'Change',
      name: 'Name:',
      plate: 'Number plate:',
      terminal: 'Terminal:',
      outTerminal: 'Return terminal:',
      yourReservation: 'Booking information',
      billingProfile: 'Billing profile:',
    },
    bkgSummaryServices: {
      detail: 'Details',
      modify: 'Change',
      remove: 'Remove',
      services: 'Services',
    },
    bkgSummaryVehicle: {
      modify: 'Change',
      edit: 'Edit',
      yourVehicle: 'Your vehicle',
    },
    bkgVehicleDialog: {
      addVehicle: 'Add vehicle',
      editVehicle: 'Edit vehicle',
      selectVehicleTitle: 'Select vehicle',
    },
    bkgVehicleDialogSelectClientCar: {
      addNewVehicle: 'Add a new vehicle',
      agree: 'Accept',
      selectVehicle: 'Select vehicle',
      selectVehicleSubtitle: 'Choose the vehicle you are parking with',
    },
    bkgVehicleDialogCompleteCarDataForm: {
      agree: 'Accept',
      body: 'Bodywork',
      completeVehicleInfo:
        'We need more information about your vehicle to give you an exact price for your service',
      kilometers: 'Kilometres',
      motor: 'Engine',
      selectBody: 'Select bodywork',
      selectMotor: 'Select engine',
    },
    bkgVehicleDialogLicensePlate: {
      agree: 'Accept',
      forgottenCarLicensePlate: 'I don’t remember the number plate',
      insertCarLicensePlate: 'What’s your car’s number plate?',
      placeholderPlate: '0000 ABC',
    },
    bkgVehicleDialogUmcSelectors: {
      addMakeModelSubtitle: 'Use vehicle make or model',
      agree: 'Accept',
      make: 'Make:',
      model: 'Model:',
      notFoundCarOption: 'I can’t find my car',
      propulsion: 'Drive:',
      selectMake: 'Select make',
      selectModel: 'Select model',
      selectPropulsion: 'Select drive',
      fromToCurrent: 'from year {{ from }}',
      fromToYear: 'between {{ from }} and {{to}}',
      year: 'Year of production',
    },
    bkgVehicleDialogNotFoundForm: {
      email: 'Email',
      color: 'Color',
      make: 'Make',
      model: 'Model',
      send: 'Send',
      text:
        'Please provide us with the make and model of your car and we will get in touch with a quote.',
    },
    bkgVehicleWarningDialog: {
      title: 'Attention!',
      text1:
        'This action will delete the selected vehicle and the previously added mechanical services.',
      text2: 'Do you want to change vehicle?',
      textModifyKm: 'All Car Services will be removed.',
      textModifyWorkshop: 'All Car Services will be removed.',
      accept: 'Accept',
      cancel: 'Cancel',
    },
    bkgLinkReservationDialog: {
      title: 'Import reservation',
      loginText: 'Login to import reservation',
      linkReservationText:
        'Your account has multiple configurations. Confirm the one you prefer to use in your reservation.',
      linkReservationTextWithoutConfigurations:
        'Confirm that you want to import booking into this account',
      forgetPassword: 'Recover password',
      password: 'Password',
      vehicle: 'Vehicle',
      profile: 'Billing data',
      saveBtn: 'Save',
      importBtn: 'Import',
      login: 'Login',
      profileCheckbox: "Don't link billing data",
      importVehicle: 'Link current vehicle',
    },
    bkgChangeUserModeDialog: {
      titleChangeBusiness: 'Do you want to switch to your company profile?',
      titleChangeParticular:
        'Do you want to switch to your particular profile?',
      bodyChangeBusiness:
        'You are booking as a particular user. If you want to make a company reservation with an invoice, click on "change to company profile". ',
      bodyChangeParticular:
        'You are booking as a business user. If you want to make a particular reservation without an invoice, click on "change to particular profile". ',
      btnChangeBusiness: 'Change to company profile',
      btnChangeParticular: 'Change to particular profile',
      btnStayAsParticular: 'Continue booking as a particular user',
      btnStayAsBusiness: 'Continue booking as a business user',
    },
  },
  servicesStep: {
    title: 'Take the opportunity to tune up your car',
    bkgExtraServices: {
      add: 'Add +',
      availableServicesFrom:
        '{{ extrasLength }} products available from {{ cheaperServiceUnitaryPrice }}€',
      desinfection: 'Car wash with disinfection',
      remove: 'Remove -',
      washes: 'Washing and disinfection',
      blockWashes: 'Service blocked by your company',
    },
    bkgCarServices: {
      add: 'Add +',
      calculatePrice: 'Calculate price',
      freeReservation: 'Your booking could be free!',
      notAvailable: 'Currently not available',
      remove: 'Remove -',
      detail: 'See detail +',
      workshopText:
        'Choose if you want to contract a service with an aparca&go workshop or with an official dealer.',
      agoWorkshop: 'aparca&go workshops',
      officialWorkshop: 'Official Dealer',
      needFees: '+ fees',
      availabilityHighDemand: 'Few places available',
      availabilityAlmostOut: 'Almost sold out',
      availabilityOutOfStock: 'Sold out',
    },
    bkgCarServicesB: {
      title: 'Car Service',
      minPriceWarranty: 'Preu mínim garantitzat',
    },
    bkgAdditionalCarServices: {
      title: 'Serveis suplementaris',
    },
  },
  travelerStep: {
    billingForm: {
      addProfile: 'Add profile',
      companyAddress: 'Address',
      companyCity: 'City',
      companyEmail: 'Invoice email',
      companyName: 'Tax name/Name and surname',
      companyState: 'Province',
      companyVat: 'CIF / NIF (Tax Code)',
      companyZip: 'Postcode',
      companyCountry: 'Country',
      createProfile: 'Create a billing profile',
      editProfile: 'Edit profile',
      editProfileTitle: 'Edit billing profile',
      needInvoiceData:
        'As required by law, all garage services require an invoice.',
      newProfileBody:
        "Create a billing profile to save your details so you don't have to enter them every time you book",
      newProfileTitle: 'New billing profile',
      profile: 'Profile',
      title: 'Invoice details',
      preventEditCorporateProfile: 'Access your personal area to modify a corporate profile',
    },
    invoiceProfileDialog: {
      accept: 'Accept',
      companyAddress: 'Address',
      companyCity: 'City',
      companyEmail: 'Invoice email',
      companyName: 'Tax name/Name and surname',
      companyState: 'Province',
      companyVat: 'CIF/NIF (Tax code)',
      companyZip: 'Postcode',
      companyCountry: 'Country',
      invoicingMethod: 'Billing method',
      monthly: 'Monthly',
      saveAsDefaultProfile: 'Save as default profile',
      service: 'Per service',
      nifError: 'This NIF belongs to a DNI, please insert name and surnames.',
      nieError: 'This NIF belongs to a NIE, please insert name and surnames.',
    },
    reservationForm: {
      addVehicle: 'Add vehicle',
      editVehicle: 'Edit vehicle',
      email: 'Email',
      name: 'Name',
      needInvoice: 'I need an invoice',
      optional: '(Optional)',
      phone: 'Telephone',
      record: 'num. File',
      recordCompany: 'Travel reference',
      signPlate: 'Number plate',
      surname: 'Surname',
      title: 'Booking details',
      travelForWork: 'I’m travelling for work',
      travelForWorkTooltip:
        'Are you traveling for work? Switch to your company profile.',
      paymethod: 'Payment method',
      paymethodComment:
        'We do not charge you now, it is to speed up your departure.',
      vehicle: 'Vehicle',
      notes: 'Comment on your booking (Optional)',
      indicateAtExit: 'Indicate it at the exit.',
      employees: 'Employees',
      employeesTooltip: 'Select the worker for whom you reserve the parking',
      yourData: 'Your data',
      modify: 'Modify',
    },
  },

};
